import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, success, alert, toFixed, GET, POST, PUT, format_date, DatePicker, getStorage, roundToTwo, total, loading } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";
import { Modal } from "react-bootstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { report_remittance_byid } from "../../components/ReportRemittanceByID.js";
import { report_remittance_1 } from "../../components/ReportRemittance01.js";
import { report_remittance_2 } from "../../components/ReportRemittance02.js";
import { report_remittance_3 } from "../../components/ReportRemittance03.js";
import { report_remittance_4 } from "../../components/ReportRemittance04.js";

const role = getStorage("role_detail");
const select_role = role?.find((item) => item.name === "remittance");
const view_r = select_role?.role[0] === 1;
const update_r = select_role?.role[2] === 1;

export default class Remittance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_update: false, modal_report: false, modal_report2: false,
      filter_data_search: "", filter_type: "", filter_start_date: "", filter_end_date: "",
      data_table: null, page: 1, data: null, data_day: [],
      rw_number: "", bill_group_id: "", deposit_date: new Date(), array_rw_number: [],
      select_month: format_date(new Date(), "yyyy-mm", "en"),
      start_date: format_date(new Date().setDate(1), "yyyy-mm-dd", "en"),
      end_date: format_date(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0), "yyyy-mm-dd", "en"),
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false); // ปิด Loading ทันทีเมื่อเข้าหน้าครั้งแรก
    if (view_r) {
      // โหลดข้อมูลพร้อมกันเพื่อความรวดเร็ว
      await Promise.all([this.GetAll(), this.GetReportDay()]);
    }
  }

  processBillData = (data, calculateFinal = false) => {
    const parseCost = (val) => Number(String(toFixed(val)).replace(/,/g, ""));
    data.forEach((d) => {
      let sums = { add_debt: 0, cable_cost: 0, change_satang: 0, common_expenses: 0, equipment_maintenance_fee: 0, late_payment: 0, meter_connect_cost: 0, other_income: 0, reduce_debt: 0, total_amount: 0, total_final: 0, waste_cost: 0, water_bill: 0, fire_cost: 0 };
      
      d.detail_rr?.filter(i => i.status_bill !== 2).forEach(item => {
        if(item.transaction_payments?.length > 0) {
          sums.change_satang += item.change_satang || 0;
          // NOTE add_on_* อยู่ที่ระดับ detail_rr ไม่ได้อยู่ใน transaction_payments — บวกครั้งเดียวต่อ 1 ใบ
          // (เดิมอ่าน tp.add_on_* ซึ่งไม่มีฟิลด์นี้ ค่าเลยหายไปทั้งก้อน)
          sums.add_debt += item.add_on_add_debt || 0;
          sums.reduce_debt += item.add_on_reduce_debt || 0;
          item.transaction_payments.forEach(tp => {
            let late = parseCost(tp.total_cost_late), common = parseCost(tp.common_expenses), cable = parseCost(tp.cable_cost), fire = parseCost(tp.fire_cost);
            sums.add_debt += tp.s_add_debt ? tp.add_debt : 0;
            sums.cable_cost += tp.s_cable_cost ? cable : 0;
            sums.common_expenses += tp.s_common_expenses ? common : 0;
            sums.equipment_maintenance_fee += tp.s_equipment_maintenance_fee ? tp.equipment_maintenance_fee : 0;
            sums.late_payment += tp.s_late_payment ? late : 0;
            sums.meter_connect_cost += tp.s_meter_connect_cost ? tp.meter_connect_cost : 0;
            sums.other_income += (tp.s_other_income ? tp.other_income : 0) + (tp.detail_rr_other?.reduce((s, o) => s + (o.cost || 0), 0) || 0);
            sums.reduce_debt += tp.s_reduce_debt ? tp.reduce_debt : 0;
            sums.total_amount += tp.total_amount || 0;
            sums.waste_cost += tp.s_waste_cost ? tp.waste_cost : 0;
            sums.water_bill += tp.s_water_bill ? tp.water_bill : 0;
            sums.fire_cost += tp.s_fire_cost ? fire : 0;
            if (!calculateFinal) sums.total_final += tp.total_final || 0;

          });
        }else{
          
        let late = parseCost(item.late_payment), common = parseCost(item.common_expenses), cable = parseCost(item.cable_cost), fire = parseCost(item.fire_cost);
        sums.add_debt += (item.s_add_debt ? item.add_debt : 0) + (item.add_on_add_debt || 0);
        sums.cable_cost += item.s_cable_cost ? cable : 0;
        sums.change_satang += item.change_satang || 0;
        sums.common_expenses += item.s_common_expenses ? common : 0;
        sums.equipment_maintenance_fee += item.s_equipment_maintenance_fee ? item.equipment_maintenance_fee : 0;
        sums.late_payment += item.s_late_payment ? late : 0;
        sums.meter_connect_cost += item.s_meter_connect_cost ? item.meter_connect_cost : 0;
        sums.other_income += (item.s_other_income ? item.other_income : 0) + (item.detail_rr_other?.reduce((s, o) => s + (o.cost || 0), 0) || 0);
        sums.reduce_debt += (item.s_reduce_debt ? item.reduce_debt : 0) + (item.add_on_reduce_debt || 0);
        sums.total_amount += item.total_amount || 0;
        sums.waste_cost += item.s_waste_cost ? item.waste_cost : 0;
        sums.water_bill += item.s_water_bill ? item.water_bill : 0;
        sums.fire_cost += item.s_fire_cost ? fire : 0;
        if (!calculateFinal) sums.total_final += item.total_final || 0;

        }
      });

      if (calculateFinal) {
        sums.total_final = sums.water_bill + sums.equipment_maintenance_fee + sums.common_expenses + sums.fire_cost + sums.waste_cost + sums.cable_cost + sums.other_income + sums.add_debt + sums.meter_connect_cost + sums.late_payment + sums.change_satang - sums.reduce_debt;
      }
      Object.assign(d, sums);
    });
    return data;
  };

  // NOTE เดิมมี CheckTotalAmount เรียกทุกครั้งที่เปิดหน้า — เอายอดหน้าบิล "ปัจจุบัน" ของทุกบิลในใบเสร็จ
  //      ไปเขียนทับยอดรายช่อง + total_amount ของใบเสร็จ (ค่าปรับของบิลถูกคิดใหม่ทีหลัง / บิลที่ไม่ได้จ่ายในใบนั้นก็ถูกรวม)
  //      แต่ total_final (เงินที่รับจริง) ไม่เปลี่ยน -> ยอดบนใบเสร็จไม่ตรงกับเงินที่รับ ถอดออกแล้ว
  //      ใบเก่าที่เพี้ยนไปแล้วซ่อมด้วย backend: python manage.py fix_receipt_totals

  GetAll = async () => {
    loading(true);
    const { filter_data_search: data_search, start_date, end_date, page } = this.state;
    try {
      const res = await GET(tokens, `v1/TH/bill-water-group/send/filter-search/page/${page}/${getStorage("project_id")}`, { data_search, start_date, end_date });
      if (res?.status) this.setState({ data: { ...res.data, data: this.processBillData(res.data.data, true) } });
    } finally { loading(false); }
  };

  GetNopageAll = async () => {
    loading(true);
    try {
      const { filter_data_search: data_search, start_date, end_date } = this.state;
      const res = await GET(tokens, `v1/TH/bill-water-group/send/filter-search/page/0/${getStorage("project_id")}`, { data_search, start_date, end_date });
      if (res?.status) this.setState({ array_rw_number: [...new Set(res.data.data.map(d => d.rw_number).filter(Boolean))] });
    } finally { loading(false); }
  };

  Update = async () => {
    loading(true);
    try {
      const res = await PUT(tokens, "v1/TH/bill-water-group/send/update", { bill_group_id: this.state.bill_group_id, deposit_date: this.state.deposit_date ? new Date(this.state.deposit_date).toISOString().split("T")[0] : "" });
      if (res?.status) {
        this.clear_form();
        success();
        this.GetAll();
      }
    } finally { loading(false); }
  };

  clear_form = () => {
    this.setState({ modal_update: false, search: "", page: 1, rw_number: "", bill_group_id: "", deposit_date: new Date(), select_month: "", start_date: "", end_date: "" });
  };

  GetReportDay = async () => {
    loading(true);
    const { filter_data_search: data_search, start_date, end_date } = this.state;
    try {
      const res = await GET(tokens, `v1/TH/bill-water-group/send/filter-search/page/0/${getStorage("project_id")}`, { data_search, start_date, end_date });
      if (res?.status) this.setState({ data_day: this.processBillData(res.data.data, true) });
    } finally { loading(false); }
  };

  GetById = async (type, item) => {
    loading(true);
    try {
      const { array_rw_number, start_date, end_date, filter_type } = this.state;
      const res = await POST(tokens, `v1/TH/bill-water-group/send/by-rw-number/${getStorage("project_id")}`, { rw_number: array_rw_number });
      
      if (!res?.status) { alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้"); this.clear_form(); return; }

      let array = res.data.data;
      array = array.map(item => {
        let txn = item.transaction_payments.length > 0 ? item.transaction_payments : item.record_water_list;
        let _total = total(txn.filter(e=> e.s_water_bill), "water_bill") +
                      total(txn.filter(e=> e.s_waste_cost), "waste_cost") +
                      total(txn.filter(e=> e.s_other_income), "other_income") +
                      total(txn.filter(e=> e.s_meter_connect_cost), "meter_connect_cost") +
                      total(txn.filter(e=> e.s_late_payment), "total_cost_late") +
                      total(txn.filter(e=> e.s_fire_cost), "fire_cost") +
                      total(txn.filter(e=> e.s_equipment_maintenance_fee), "equipment_maintenance_fee") +
                      total(txn.filter(e=> e.s_common_expenses), "common_expenses") +
                      total(txn.filter(e=> e.s_cable_cost), "cable_cost") +
                      (total(txn.filter(e=> e.s_add_debt), "add_debt") + item.add_on_add_debt) -
                      (total(txn.filter(e=> e.s_reduce_debt), "reduce_debt") + item.add_on_reduce_debt)
        return{
        ...item,
        water_bill: total(txn.filter(e=> e.s_water_bill), "water_bill"),
        waste_cost: total(txn.filter(e=> e.s_waste_cost), "waste_cost"),
        other_income: total(txn.filter(e=> e.s_other_income), "other_income"),
        meter_connect_cost: total(txn.filter(e=> e.s_meter_connect_cost), "meter_connect_cost"),
        late_payment: total(txn.filter(e=> e.s_late_payment), "total_cost_late"),
        fire_cost: total(txn.filter(e=> e.s_fire_cost), "fire_cost"),
        equipment_maintenance_fee: total(txn.filter(e=> e.s_equipment_maintenance_fee), "equipment_maintenance_fee"),
        common_expenses: total(txn.filter(e=> e.s_common_expenses), "common_expenses"),
        cable_cost: total(txn.filter(e=> e.s_cable_cost), "cable_cost"),
        add_debt: total(txn.filter(e=> e.s_add_debt), "add_debt"),
        reduce_debt: total(txn.filter(e=> e.s_reduce_debt), "reduce_debt"),
        total_amount: _total,
        total_final: _total
      }})

      if (start_date && ["allpdf", "allpdf2", "allexcel", "allexcel2", "2"].includes(type)) {
        const startMs = format_date(start_date, "date").getTime(), endMs = format_date(end_date, "date").getTime();
        array = array.filter(e => { const rMs = format_date(e.record_date, "date").getTime(); return rMs >= startMs && rMs <= endMs; });
      }

      const numFilter = Number(filter_type);
      const fPay = (arr) => arr.filter(e => e.payment_type === numFilter);
      const fMon = (arr) => arr.filter(e => new Date(new Date(e.transfer_date).setDate(1)) < new Date(new Date(e.record_date).setDate(1)));
      const tDate = start_date || new Date();

      if (type === "allpdf") report_remittance_3(fPay(array), tDate, numFilter);
      else if (type === "allpdf2") report_remittance_4(fMon(fPay(array)), tDate, numFilter);
      else if (type === "2") report_remittance_2(array, tDate);
      else if (type.startsWith("allexcel")) {
        let excelArr = type === "allexcel2" ? fMon(fPay(array)) : fPay(array);
        let sums = { water: 0, eq: 0, common: 0, waste: 0, other: 0, debt: 0, meter: 0, late: 0, satang: 0, total: 0 };

        const data = excelArr.map((item, i) => {
          // add_on_* ต้องล้างด้วย ไม่งั้นใบที่ยกเลิกยังโผล่ในคอลัมน์เพิ่ม/ลดหนี้และยอดรวม
          if (item.status_bill === 2) Object.assign(item, { water_bill: 0, equipment_maintenance_fee: 0, common_expenses: 0, waste_cost: 0, other_income: 0, add_debt: 0, reduce_debt: 0, meter_connect_cost: 0, late_payment: 0, change_satang: 0, total_final: 0, add_on_add_debt: 0, add_on_reduce_debt: 0 });
          item.count_bill = item.count_bill || 1;
          // ใบรายรับอื่นๆ ให้ใช้ราคาของรายการนั้นแทน (ใบที่ยกเลิกต้องคงเป็น 0 ห้ามดึงกลับ)
          if (item.status_bill !== 2) item.other_income = item.record_other_list?.[0]?.cost ?? item.other_income;

          const iOther = item.other_income + item.fire_cost + item.cable_cost;
          const iDebt = item.add_debt + item.add_on_add_debt - (item.reduce_debt + item.add_on_reduce_debt);
          sums.water += item.water_bill; sums.eq += item.equipment_maintenance_fee; sums.common += item.common_expenses; sums.waste += item.waste_cost; sums.other += iOther; sums.debt += iDebt; sums.meter += item.meter_connect_cost; sums.late += item.late_payment; sums.satang += item.change_satang; sums.total += item.total_final;

          return (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{item.iw_number}</td>
              <td>{format_date(item.record_date, "dd/mm/yyyy")}</td>
              <td>{item.address_number || item.address || "-"}</td>
              <td>{item.full_name}</td>
              <td>{item.status_bill === 2 ? "ยกเลิก" : `ชำระ ${item.count_bill} รายการ ${item.rw_number}`}</td>
              <td>{item.status_bill !== 2 && item.payment_type === 2 ? format_date(item.transfer_date, "dd/mm/yyyy") : ""}</td>
              <td>{toFixed(item.water_bill)}</td>
              <td>{toFixed(item.equipment_maintenance_fee)}</td>
              <td>{toFixed(item.common_expenses)}</td>
              <td>{toFixed(item.waste_cost)}</td>
              <td>{toFixed(iOther)}</td>
              <td>{toFixed(iDebt)}</td>
              <td>{toFixed(item.meter_connect_cost)}</td>
              <td>{toFixed(item.late_payment)}</td>
              <td>{toFixed(item.change_satang)}</td>
              <td>{toFixed(item.total_final)}</td>
            </tr>
          );
        });

        data.push(
          <tr key="totals"><td colSpan={6}></td>
          <td>รวมทั้งสิ้น</td>
          <td>{toFixed(sums.water)}</td>
          <td>{toFixed(sums.eq)}</td>
          <td>{toFixed(sums.common)}</td>
          <td>{toFixed(sums.waste)}</td>
          <td>{toFixed(sums.other)}</td>
          <td>{toFixed(sums.debt)}</td>
          <td>{toFixed(sums.meter)}</td>
          <td>{toFixed(sums.late)}</td>
          <td>{toFixed(sums.satang)}</td>
          <td>{toFixed(sums.total)}</td></tr>
        );
        this.setState({ data_table: data }, () => setTimeout(() => document.getElementById("export_excel")?.click(), 3000));
      } else report_remittance_byid(array, item);
    } finally { loading(false); }
  };

  GetById2 = async (type, item) => {
    loading(true);
    try {
      const { start_date, end_date } = this.state;
      const res = await GET(tokens, `v1/TH/report/receipt/filter-search/${getStorage("project_id")}`, { address_number: "", start_date, end_date });
      if (res?.status) {
        console.log("res.data.data:",res.data.data)
        let array = res.data.data.filter(d => d.record_water_list?.length > 0 && d.rw_number);
        const pCost = (val) => Number(String(toFixed(val)).replace(/,/g, ""));
        const fields = [ ["s_cable_cost", "cable_cost", "cable_cost"], ["s_common_expenses", "common_expenses", "common_expenses"], ["s_equipment_maintenance_fee", "equipment_maintenance_fee", "equipment_maintenance_fee"], ["s_fire_cost", "fire_cost", "fire_cost"], ["s_late_payment", "late_payment", "total_cost_late"], ["s_meter_connect_cost", "meter_connect_cost", "meter_connect_cost"], ["s_other_income", "other_income", "other_income"], ["s_waste_cost", "waste_cost", "waste_cost"], ["s_water_bill", "water_bill", "water_bill"] ];

        array = array.map(d => {
          {
          ["late_payment", "common_expenses", "cable_cost", "fire_cost"].forEach(k => d[k] = pCost(d[k]));
          if(d.transaction_payments?.length > 0){
            d.transaction_payments.forEach((rw, i) => {
            ["total_cost_late", "common_expenses", "cable_cost", "fire_cost"].forEach(k => rw[k] = pCost(rw[k]));
            let t = 0; const isFirst = i === 0;
            fields.forEach(([s, iK, rK]) => { if (!d[s]) { d[iK] = 0; rw[rK] = 0; } else t += rw[rK] || 0; });
            d.add_debt = rw.add_debt = !d.s_add_debt ? (isFirst ? d.add_on_add_debt || 0 : 0) : (t += rw.add_debt || 0, rw.add_debt);
            d.reduce_debt = rw.reduce_debt = !d.s_reduce_debt ? (isFirst ? d.add_on_reduce_debt || 0 : 0) : (t -= rw.reduce_debt || 0, rw.reduce_debt);
            t += isFirst ? (d.add_on_add_debt || 0) - (d.add_on_reduce_debt || 0) : 0;
            d.total_amount = rw.total_amount = roundToTwo(t);
          });
          d.add_debt += total(d.transaction_payments, "add_debt");
          d.reduce_debt += total(d.transaction_payments, "reduce_debt");
          }else{
            d.record_water_list.forEach((rw, i) => {
            ["total_cost_late", "common_expenses", "cable_cost", "fire_cost"].forEach(k => rw[k] = pCost(rw[k]));
            let t = 0; const isFirst = i === 0;
            fields.forEach(([s, iK, rK]) => { if (!d[s]) { d[iK] = 0; rw[rK] = 0; } else t += rw[rK] || 0; });
            d.add_debt = rw.add_debt = !d.s_add_debt ? (isFirst ? d.add_on_add_debt || 0 : 0) : (t += rw.add_debt || 0, rw.add_debt);
            d.reduce_debt = rw.reduce_debt = !d.s_reduce_debt ? (isFirst ? d.add_on_reduce_debt || 0 : 0) : (t -= rw.reduce_debt || 0, rw.reduce_debt);
            t += isFirst ? (d.add_on_add_debt || 0) - (d.add_on_reduce_debt || 0) : 0;
            d.total_amount = rw.total_amount = roundToTwo(t);
          });
          d.add_debt += total(d.record_water_list, "add_debt");
          d.reduce_debt += total(d.record_water_list, "reduce_debt");
          }
        }
        return d;
      });
      console.log("array:",array)
        report_remittance_2(array, start_date || new Date());
      }
    } finally { loading(false); }
  };

  ExportReport = async (type) => {
    loading(true);
    const { start_date, end_date } = this.state;
    try {
      const res = await GET(tokens, `v1/TH/bill-water-group/send/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", start_date, end_date });
      this.setState({ array_rw_number: res?.status ? [...new Set(res.data.data.map(d => d.rw_number).filter(Boolean))] : [] }, () => this.GetById(`all${type}`, null));
    } catch { loading(false); }
  };

  render() {
    const { data, data_day, start_date, end_date, select_month, filter_type, modal_update, modal_report, modal_report2, rw_number, deposit_date } = this.state;
    const paymentLabels = ["-", "บัญชีค่าน้ำ และส่วนกลาง", "โอนเงินเข้าบัญชีนิติ", "เงินกองทุน"];

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="การนำส่งเงินค่าใช้จ่าย" />
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3"><b>การนำส่งเงินค่าใช้จ่าย</b></h4>
                {view_r && (
                  <div className="d-flex row mx-0">
                    <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => report_remittance_1(data_day || [], start_date || new Date())}> พิมพ์รายงานจัดเก็บประจำวัน </button>
                    <button className="btn btn-outline-primary mx-1 mb-3" onClick={async () => { await this.GetNopageAll(); this.GetById2("2", null); }}> พิมพ์รายงานจัดเก็บประจำเดือน </button>
                    <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => this.setState({ modal_report: true, filter_type: "1" })}> พิมพ์รายงานรับเงินประจำเดือน </button>
                    <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => this.setState({ modal_report2: true, filter_type: "2" })}> พิมพ์รายงานเงินโอนนำส่งแล้ว </button>
                  </div>
                )}
              </div>
              
              {view_r && (
                <div className="d-flex justify-content-between">
                  <div className="d-flex row mx-0">
                    <input type="search" className="form-control wpx-200 bg-contain border-0 mx-1 mb-3" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ filter_data_search: e.target.value })} />
                    <input type="month" className="form-control wpx-200 bg-contain border-0 mx-1 mb-3" value={select_month} onChange={(e) => {
                        this.setState({ select_month: e.target.value });
                        if (e.target.value) {
                          let d = new Date(`${e.target.value}-01`), ed = new Date(d.setMonth(d.getMonth() + 1));
                          this.setState({ start_date: format_date(new Date(`${e.target.value}-01`), "yyyy-mm-dd", "en"), end_date: format_date(new Date(ed.setDate(ed.getDate() - 1)), "yyyy-mm-dd", "en") });
                        } else this.setState({ start_date: "", end_date: "" });
                      }}
                    />
                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, () => { this.GetAll(); this.GetReportDay(); })}>ค้นหา</button>
                    <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_data_search: "", start_date: "", end_date: "", select_month: "", page: 1 }, () => { this.GetAll(); this.GetReportDay(); })}>รีเซ็ท</button>
                  </div>
                </div>
              )}

              <div className="table-responsive mb-3">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {["เลขที่ใบเสร็จรับเงิน", "ปิดงานประจำวันที่", "บัญชีนำฝาก", "จำนวนเงินฝาก", "วันที่นำเงินฝากธนาคาร", "เลขที่ใบเสร็จใบแรก", "เลขที่ใบเสร็จใบสุดท้าย", "ค่าน้ำประปา", "ค่ารักษาอุปกรณ์น้ำ", "ค่าส่วนกลาง", "ค่าขยะ", "ค่าเคเบิล", "รายรับอื่นๆ", "ค่าเบี้ยประกัน", "เพิ่ม/ลดหนี้", "ค่าต่อกลับมิเตอร์", "ค่าปรับชำระล่าช้า", "ปรับยอดเงิน", "รวมเป็นเงิน", "พิมพ์รายงาน"].map((h, i) => (
                        <th key={i} className="text-nowrap text-left">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {!data?.data?.length ? (
                      <tr><td colSpan={20} className="text-center"> ไม่มีข้อมูล </td></tr>
                    ) : (
                      data.data.map((item, index) => (
                        <tr key={index}>
                          <td>{item.rw_number || "-"}</td>
                          <td>{item.close_job_date ? format_date(item.close_job_date, "dd/mm/yy") : "-"}</td>
                          <td className="text-nowrap">{paymentLabels[item.payment_type] || "-"}</td>
                          <td>{toFixed(
                            item.water_bill+
item.equipment_maintenance_fee+
item.common_expenses+
item.waste_cost+
item.cable_cost+
item.other_income+
item.fire_cost+
item.meter_connect_cost+
item.late_payment+
item.change_satang+
// NOTE add_debt/reduce_debt ผ่าน processBillData มาแล้ว รวม add_on_* ไว้ในตัวเอง — บวกซ้ำตรงนี้จะได้ 2 เท่า
((item.add_debt || 0) - (item.reduce_debt || 0))

                          )}</td>
                          <td className="text-center">
                            {item.deposit_date ? format_date(item.deposit_date, "dd/mm/yy") : (new Date() - new Date(item.close_job_date) > 172800000) ? (
                                <label className="text-danger pointer" data-toggle="tooltip" title="ผิดปกติ ยังไม่บันทึกการนำฝากเงิน" onClick={() => update_r && this.setState({ modal_update: true, bill_group_id: item.bill_group_id, rw_number: item.rw_number })}>ผิดปกติ</label>
                              ) : (
                                <label className="text-warning pointer" onClick={() => update_r && this.setState({ modal_update: true, bill_group_id: item.bill_group_id, rw_number: item.rw_number })}>ไม่ได้บันทึก</label>
                            )}
                          </td>
                          <td>{item.first_iw_number || "-"}</td>
                          <td>{item.last_iw_number || "-"}</td>
                          <td>{toFixed(item.water_bill || 0)}</td>
                          <td>{toFixed(item.equipment_maintenance_fee || 0)}</td>
                          <td>{toFixed(item.common_expenses || 0)}</td>
                          <td>{toFixed(item.waste_cost || 0)}</td>
                          <td>{toFixed(item.cable_cost || 0)}</td>
                          <td>{toFixed(item.other_income || 0)}</td>
                          <td>{toFixed(item.fire_cost || 0)}</td>
                          {/* add_debt/reduce_debt รวม add_on_* มาแล้วจาก processBillData — บวกซ้ำจะได้ 2 เท่า */}
                          <td>{toFixed((item.add_debt || 0) - (item.reduce_debt || 0))}</td>
                          <td>{toFixed(item.meter_connect_cost || 0)}</td>
                          <td>{toFixed(item.late_payment || 0)}</td>
                          <td>{toFixed(item.change_satang || 0)}</td>
                          <td>{toFixed(
                            item.water_bill+
item.equipment_maintenance_fee+
item.common_expenses+
item.waste_cost+
item.cable_cost+
item.other_income+
item.fire_cost+
item.meter_connect_cost+
item.late_payment+
item.change_satang+
// NOTE add_debt/reduce_debt ผ่าน processBillData มาแล้ว รวม add_on_* ไว้ในตัวเอง — บวกซ้ำตรงนี้จะได้ 2 เท่า
((item.add_debt || 0) - (item.reduce_debt || 0))

                          )}</td>
                          <td className="text-center">
                            <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mr-2">
                              <label className="icon mx-2 text-primary pointer" onClick={() => this.setState({ array_rw_number: [item.rw_number] }, () => this.GetById("by_id", item))}>{"\uf02f"}</label>
                            </label>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {data?.data?.length > 0 && (
                <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                  <div><label> แสดง {data.end_index} รายการ จาก {data.count} รายการ </label></div>
                  <Pagination count={data.page_number} page={this.state.page} color="primary" showFirstButton showLastButton onChange={(event, value) => this.setState({ page: value }, () => this.GetAll())} />
                </div>
              )}
              
              <table ref={this.tableRef} className="d-none">
                <thead><tr>{["ลำดับ", "เลขที่ใบเสร็จรับเงิน", "วันที่ใบเสร็จรับเงิน", "บ้านเลขที่", "ชื่อ-นามสกุล", "ชำระ", "วันที่โอน", "ค่าน้ำประปา", "ค่ารักษาอุปกรณ์น้ำ", "ค่าส่วนกลาง", "ค่าขยะ", "รายรับอื่นๆ", "เพิ่ม/ ลดหนี้", "ค่าต่อกลับมิเตอร์", "ค่าปรับชำระล่าช้า", "ปรับเศษ", "รวมทั้งสิ้น"].map(h => <td key={h}>{h}</td>)}</tr></thead>
                <tbody>{this.state.data_table}</tbody>
              </table>
            </div>
          </div>
        </div>

        {/* MODAL UPDATE */}
        <Modal show={modal_update} onHide={() => this.setState({ modal_update: false })}>
          <Modal.Header><Modal.Title><b>ลงข้อมูลวันที่นำเงินฝากธนาคาร</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">เลขที่ใบเสร็จรับเงิน:</label><input className="form-control border-0 bg-contain" type="text" value={rw_number} readOnly /></div>
            <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">วันที่นำเงินฝากธนาคาร:</label><DatePicker className="form-control bg-contain border-0" onChange={(e) => this.setState({ deposit_date: e })} value={deposit_date} /></div>
            <div className="w-100 d-flex"><div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_update: false })}>ยกเลิก</button></div><div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={this.Update}>ยืนยัน</button></div></div>
          </Modal.Body>
        </Modal>

        {/* MODAL REPORT 1 */}
        <Modal show={modal_report} onHide={() => this.setState({ modal_report: false })}>
          <Modal.Header><Modal.Title><b>รายงานเงินประจำเดือน</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">ประเภทการชำระ:</label><select className="form-control bg-contain border-0" onChange={(e) => this.setState({ filter_type: e.target.value })} value={filter_type}><option value="1">เงินสด</option><option value="2">เงินโอน</option></select></div>
            <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">วันที่เริ่มต้น:</label><DatePicker className="form-control bg-contain border-0" onChange={(e) => this.setState({ start_date: e })} value={start_date} /></div>
            <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">วันที่สิ้นสุด:</label><DatePicker className="form-control bg-contain border-0" onChange={(e) => this.setState({ end_date: e })} value={end_date} /></div>
            <div className="w-100 d-flex"><div className="w-100 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_report: false })}>ยกเลิก</button></div><div className="w-100 p-1"><button className="btn btn-primary w-100" onClick={() => this.ExportReport("pdf")}>PDF</button></div>
              <div className="w-100 p-1">
                <button className="btn btn-info w-100" onClick={() => this.ExportReport("excel")}>EXCEL</button>
                <DownloadTableExcel filename={`รายงาน${filter_type === "1" ? "เงินสด" : "เงินโอน"}ที่ได้รับแจ้ง`} sheet={`รายงาน${filter_type === "1" ? "เงินสด" : "เงินโอน"}ที่ได้รับแจ้ง`} currentTableRef={this.tableRef.current}><button className="d-none" id="export_excel"></button></DownloadTableExcel>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* MODAL REPORT 2 */}
        <Modal show={modal_report2} onHide={() => this.setState({ modal_report2: false })}>
          <Modal.Header><Modal.Title><b>รายงานเงินประจำเดือน</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">เดือนที่:</label><input type="month" className="form-control bg-contain border-0" onChange={(e) => { let d = new Date(`${e.target.value}-01`), ed = new Date(d.setMonth(d.getMonth() + 1)); this.setState({ start_date: format_date(new Date(`${e.target.value}-01`), "yyyy-mm-dd", "en"), end_date: format_date(new Date(ed.setDate(ed.getDate() - 1)), "yyyy-mm-dd", "en") }); }}/></div>
            <div className="w-100 d-flex"><div className="w-100 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_report2: false })}>ยกเลิก</button></div><div className="w-100 p-1"><button className="btn btn-primary w-100" onClick={() => this.ExportReport("pdf2")}>PDF</button></div>
              <div className="w-100 p-1">
                <button className="btn btn-info w-100" onClick={() => this.ExportReport("excel2")}>EXCEL</button>
                <DownloadTableExcel filename="รายงานเงินโอนนำส่งแล้ว" sheet="รายงานเงินโอนนำส่งแล้ว" currentTableRef={this.tableRef.current}><button className="d-none" id="export_excel"></button></DownloadTableExcel>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}